import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { SettingsZsmFormsQuery } from '@custom/schema';

export function useSettingsZSMFormsQuery() {
  return useStaticQuery(graphql(SettingsZsmFormsQuery));
}
